import { DASHBOARD, SUMMARY } from "../constants/apis";

// GET /dashboard/summary: one object per section the user is allowed to read (absent =
// no permission, null = failed server-side). It rethrows, and treats an empty body as an
// error: an empty summary would read as "nothing needs attention".
const getDashboardSummary = async (axiosInstance) => {
  try {
    const response = await axiosInstance.get(`${DASHBOARD}${SUMMARY}`, {
      withCredentials: true,
    });
    if (!response?.data) throw new Error("Empty dashboard summary");
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export { getDashboardSummary };
